import { AuthMethod } from '@infotech-soe/merps/types/session';

import {
  convertBase64toJSON,
  convertJSONtoBase64,
  decryptWithFingerprint,
  encryptWithFingerprint,
} from '../../helpers';

import { STORAGE_KEYS } from './common';
import ILocalConfigurationService from './ILocalConfigurationService';

export type Credentials = {
  user: string;
  pass: string;
  app: string | null;
};

class LocalConfigurationServiceSingleton implements ILocalConfigurationService {
  private storedCredentials: Credentials | undefined = undefined;

  constructor() {
    const storedCredentials = sessionStorage.getItem(
      STORAGE_KEYS.STORED_CREDENTIALS
    );
    if (storedCredentials) {
      this.storedCredentials = convertBase64toJSON<Credentials>(
        decryptWithFingerprint(storedCredentials)
      );
    }
  }

  public getDefaultConnectionURL(): string {
    return process.env.CONSOLE_SERVER_URL ?? '';
  }

  public getDefaultApplication(): string {
    return this.storedCredentials
      ? this.storedCredentials.app ||
          localStorage.getItem(STORAGE_KEYS.APP) ||
          ''
      : (localStorage.getItem(STORAGE_KEYS.APP) ??
          process.env.DEFAULT_APPLICATION ??
          '');
  }

  public getStoredUser(): string {
    return this.storedCredentials?.user ?? '';
  }

  public getStoredPassword(): string {
    return this.storedCredentials?.pass ?? '';
  }

  public storeDevCredentials(
    user: string,
    pass: string,
    app: string | null
  ): void {
    const credentials = encryptWithFingerprint(
      convertJSONtoBase64<Credentials>({
        user,
        pass,
        app,
      })
    );
    sessionStorage.setItem(STORAGE_KEYS.STORED_CREDENTIALS, credentials);
  }

  public getPreferredAuthMethod(): AuthMethod | undefined {
    return localStorage.getItem(STORAGE_KEYS.PREFERRED_AUTH_METHOD) as any;
  }

  public storeLastUsedAuthMethod(method: AuthMethod): void {
    localStorage.setItem(STORAGE_KEYS.PREFERRED_AUTH_METHOD, method);
  }
}

const LocalConfigurationService = (() => {
  let instance: ILocalConfigurationService;
  return new Proxy(LocalConfigurationServiceSingleton, {
    construct(Target): ILocalConfigurationService {
      if (!instance) {
        instance = new Target();
      }
      return instance;
    },
  });
})();

export default LocalConfigurationService;
